import React, { FC } from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  bookingActionItemContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: 1,
    gap: '12px',
  },
}));

interface IBookingActionItemContainer {
  message: string;
  children?: JSX.Element | null;
}

const BookingActionItemContainer: FC<IBookingActionItemContainer> = ({ message, children }) => {
  const classes = useStyles();

  return (
    <Box className={classes.bookingActionItemContainer}>
      <Typography>{message}</Typography>
      {children}
    </Box>
  );
};

export default BookingActionItemContainer;
